import React, { Component } from 'react'
import { Page, ButtonWithLoader } from '../../../core'
import { ModalBody, ModalHeader, Modal, Button } from 'reactstrap'
import { middlewareService } from '../../../shared/service';
import { onboardingService } from '../../services/onboarding';
import { toast } from 'react-toastify';
import { utils } from "../../../core/helpers/utils";

let recorder = null;
export default class IpvUploadTest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldStop: false,
      stopped: false,
      stream: null,
      recording: false,
      isLocationEnabled: false,
      retake: 0,
      data: {}
    }
  }

  componentDidMount() {
    this.requestVideo();
  }

  handleSuccess = (stream) => {
    this.enableLocation()
    this.setState({
      stream: stream,
      videoLoaded: true
    })
    this.video.srcObject = stream;
    this.video.play();
  }

  handleFailure = () => {
    this.setState({
      failed: true
    })
  }

  showError = (error) => {
    this.setState({
      isLocationEnabled: false
    })
    return toast.error("Please Enable your location first")
  }

  enableLocation = () => {
    let locationEnabled = false;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        locationEnabled = true;
        this.setState({
          isLocationEnabled: true,
          locationLoaded: true
        })

        let url = process.env.REACT_APP_GET_CLIENT_IP;

        middlewareService.getApiData(url)
          .then(result => {
            const response = utils.parsePayload(result);
            this.setState({
              ipAddr: response.ip,
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            })
          })
        this.record()
      }, this.showError);
    } else {
      console.log("not supported")
    }
    return locationEnabled;
  }


  record = () => {
    recorder = new MediaRecorder(this.state.stream, {
      mimeType: 'video/webm'
    });

    this.setState({
      recording: true,
      retake: this.state.retake + 1
    })

    setTimeout(() => {
      this.state.recording && this.stopRecording();
    }, 10000)

    recorder.start();
  }

  requestVideo = () => {
    navigator && navigator.mediaDevices.getUserMedia({
      video: true,
      audio: true
    })
      .then(this.handleSuccess).catch(this.handleFailure);
  }



  startRecording = () => {
    if (!this.state.isLocationEnabled) {
      let locationEnabled = this.enableLocation();
    } else {
      this.record();
    }
  }




  stopRecording = () => {
    recorder.ondataavailable = e => {
      var file = new File([e.data], "ipv.webm", {
        type: "video/webm",
      });
      let data = {}
      data.target = { name: "ipv", files: [file] }
      this.setState({
        videoData: data,
        retake: this.state.retake + 1
      })
      // var blobUrl = URL.createObjectURL(file);
      // var link = document.createElement("a"); // Or maybe get it from the current document
      // link.href = blobUrl;
      // link.download = "aDefaultFileName.webm";
      // link.innerHTML = "Click here to download the file";
      // link.click()
    };

    this.setState({
      recording: false
    })

    recorder.stop();
  }

  submit = () => {
    this.props.onChange(this.state.videoData, this.props.index);
    this.storeData()
    this.stopVideo()
  }

  stopVideo = () => {
    const stream = this.video.srcObject;
    const tracks = stream.getTracks();

    tracks.forEach(function (track) {
      track.stop();
    });

    this.video.srcObject = null;
    this.props.close('openIpvModal');
  }

  storeData = () => {
    let payload = {
      "pan": this.props.pan,
      "ip": this.state.ipAddr,
      "latitude": this.state.latitude,
      "longitude": this.state.longitude
    }
    onboardingService.storeData(payload)
  }

  retake = () => {
    this.setState({
      videoData: {},
      retake: 0
    })
  }

  closeModal = () => {
    this.setState({
      shouldStop: false,
      stopped: false,
      stream: null,
      recording: false,
      isLocationEnabled: false,
      retake: 0,
      data: {},
      videoLoaded: false,
    }, () => {
      this.props.close('openIpvModal')
    })
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen}
        toggle={this.closeModal}
        className="modal-md">
        <ModalHeader toggle={this.closeModal}>
        </ModalHeader>
        <ModalBody>
          {
            !this.state.videoLoaded ?
              this.state.failed ?
                <div className="font-weight-semi-bold"><center>Please Enable Your Camera and Microphone access!</center></div>
                :
                <div>Loading...</div>
              :
              <div className="d-flex flex-column">
                <video id='video' className="pb-0 ipv-video" ref={(el) => { this.video = el }} autoplay={true} muted={true}></video>
                <div className="d-flex flex-column align-items-center">
                  <div className="font-weight-normal font-size-14">
                    Press Record Button and say onscreen OTP
                </div>
                  <div className="font-weight-semi-bold font-size-24">
                    {this.props.otp}
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  {
                    this.state.retake !== 2 &&
                    <ButtonWithLoader
                      text={!this.state.recording ? "Start" : "stop"}
                      color={!this.state.recording ? "primary" : "danger"}
                      className="w-100 mx-1"
                      onClick={!this.state.recording ? () => this.startRecording() : () => this.stopRecording()}
                    />
                  }
                  {
                    this.state.retake === 2 &&
                    <React.Fragment>
                      <ButtonWithLoader
                        text={"retake"}
                        color="danger"
                        className="w-100 mx-1"
                        onClick={this.retake}
                      />
                      <ButtonWithLoader
                        text={"submit"}
                        color="primary"
                        className="w-100 mx-1"
                        onClick={this.submit}
                      />
                    </React.Fragment>
                  }
                </div>
              </div>
          }
        </ModalBody>
      </Modal>

    )
  }
}
